exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.Outdated {\n  position: fixed;\n  top: 0;\n  z-index: 999;\n  width: 100%;\n  padding: 30px 10px 0;\n  background: #F0584E;\n  color: #fff;\n  text-align: center;\n  font-size: 0.85em;\n}\n.Outdated .btn,\n.Outdated h2 { color: #fff;\n}\n.Outdated .btn:hover {\n  color: #F0584E\n}\n.browser-close {\n  position: absolute;\n  top: 5px;\n  right: 10px;\n  cursor: pointer;\n}\n\n\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5cce9571","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Outdated.vue
// module id = 586
// module chunks = 1